import React from 'react';
import Profile from '../../PasswordReset/Profile';
import { Link } from 'react-router-dom';

const Settings = () => {
  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sidebar */}
      {/* Sidebar */}
      <div className="w-1/5 bg-gray-100 border-r text-black hover:text-gray-800 p-4">
        <h1 className="text-xl font-bold mb-4">Settings</h1>
        <div>
          {/* Sidebar Links */}
          <Link
            to="/dashboard/system-config/wide-settings"
            className="w-full block text-left py-2 px-4 mb-2 rounded  bg-black text-white "
          >
            General
          </Link>
          <Link
            to="/dashboard/system-config/preferences"
            className="w-full block text-left py-2 px-4 mb-2 rounded hover:bg-gray-200"
          >
            Preferences
          </Link>

          <Link
            to="/dashboard/system-config/notifications"
            className="w-full block text-left py-2 px-4 mb-2 rounded hover:bg-gray-200"
          >
            Notifications
          </Link>

          <Link
            to="/dashboard/system-config/language"
            className="w-full block text-left py-2 px-4 mb-2 rounded hover:bg-gray-200"
          >
            Language Settings
          </Link>

          <Link
            to="/dashboard/system-config/currency"
            className="w-full block text-left py-2 px-4 mb-2 rounded hover:bg-gray-200"
          >
            Currency Settings
          </Link>

          <Link
            to="/dashboard/system-config/hotel-config"
            className="w-full block text-left py-2 px-4 mb-2 rounded hover:bg-gray-200"
          >
            Hotel Configuration
          </Link>
        </div>
      </div>
      {/* Main Content */}
      <main className="flex-grow p-8 w-5/6">
        <h2 className="text-2xl text-black font-bold">Settings &gt; General</h2>
        <Profile />
      </main>
    </div>
  );
};

export default Settings;
